export default "__VITE_ASSET__CFfmarHU__"